export function apiPutRequest(url, dataRequest) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      type: 'PUT',
      dataType: 'json',
      data: JSON.stringify(dataRequest),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function (data) {
        resolve(data)
      },
      error: function (error) {
        reject(error)
      },
    })
  })
}

export default apiPutRequest;
